import { render, staticRenderFns } from "./AdvancedTab.vue?vue&type=template&id=39aed238&scoped=true"
import script from "./AdvancedTab.vue?vue&type=script&lang=ts"
export * from "./AdvancedTab.vue?vue&type=script&lang=ts"
import style0 from "./AdvancedTab.vue?vue&type=style&index=0&id=39aed238&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39aed238",
  null
  
)

export default component.exports